<template>
  <div class="filters">
    <ul class="header-f">
      <li class="filter-btn" :class="isActive('entry', entry.value)" v-for="(entry, i) in entries" :key="i" @click="setEntry(entry)">
        {{$t(`attractions.${entry.value}.text`)}}
      </li>
    </ul>
    <ul v-if="filters.entry == 'evasion'">
      <li :class="isActive('age', age.value)" v-for="(age, i) in ages" :key="i" @click="setAge(age)">{{$t(`attractions.ages.${age.value}`)}}</li>
    </ul>
    <!-- <vue-markdown class="markdown" v-html="text.value">!</vue-markdown> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      entries: [
        /*{
          text: "Zen",
          value: "zen",
          desc: "Entrée Zen : Accès au parc et aux espaces détente"
        },
        {
          text: "Délire",
          value: "delire",
          desc:
            "Entrée Délire : Accès aux jeux et aux attractions au sol, hors parcours dans les arbres"
        },*/
        {
          text: "Entrée Evasion",
          value: "evasion",
          desc: "Entrée Evasion : Accès complet à toutes les attractions du parc et les parcours dans les arbres",
        },
      ],
      ages: [
        {
          text: "3 à 4 ans",
          value: "3-4ans",
        },
        {
          text: "5 à 8 ans",
          value: "5-8ans",
        },
        {
          text: "9 ans et plus",
          value: "9+",
        },
      ],
      text: {
        value: `
      - Entrée Zen : Accès au parc et aux espaces détente
      - Entrée Délire : Accès aux jeux et aux attractions au sol, hors parcours dans les arbres
      - Entrée Evasion : Accès complet à toutes les attractions du parc et les parcours dans les arbres `,
      },
    };
  },
  methods: {
    setEntry(entry) {
      this.$store.commit("SET_ENTRY", entry.value);
    },
    setAge(age) {
      this.$store.commit("SET_AGE", age.value);
    },
    isActive(name, value) {
      return this.filters[name] === value ? "active" : "";
    },
  },
  computed: {
    filters() {
      return this.$store.getters.filters;
    },
  },
};
</script>

<style lang="scss">
.filters {
  max-width: $max-width;
  margin: auto;
  padding-bottom: 2em;
  > .header-f {
    li {
      grid-column: 1 / span 3;
    }
  }
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    width: 700px;
    margin: auto;
    margin-bottom: 20px;

    li {
      transition: transform 0.2s ease-in-out;
      flex: 1;
      text-align: center;
      cursor: pointer;
      padding: 20px 30px;
      background-color: white;
      font-family: Luckiest Guy, cursive;
      color: #555;

      border-radius: 10px;

      &.active {
        background-color: $primary;
        color: #fff;
      }
      &:hover {
        transform: scale(1.1);
        background-color: $primary;
        color: white;
      }
      p {
        font-size: 15px;
        font-family: "Quicksand", sans-serif;
      }
    }
  }
  .markdown {
    max-width: $max-width;
    margin: 1em 0;
  }
}

@media screen and(max-width:$desktop) {
  .filters {
    margin: auto;

    ul {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      li:first-of-type {
        animation: heartbeat 1.5s ease-in-out 4 both;
        @-webkit-keyframes heartbeat {
          from {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: center center;
            transform-origin: center center;
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          10% {
            -webkit-transform: scale(0.91);
            transform: scale(0.91);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          17% {
            -webkit-transform: scale(0.98);
            transform: scale(0.98);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          33% {
            -webkit-transform: scale(0.87);
            transform: scale(0.87);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          45% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
        }
        @keyframes heartbeat {
          from {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: center center;
            transform-origin: center center;
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          10% {
            -webkit-transform: scale(0.91);
            transform: scale(0.91);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          17% {
            -webkit-transform: scale(0.98);
            transform: scale(0.98);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          33% {
            -webkit-transform: scale(0.87);
            transform: scale(0.87);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          45% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
        }
      }
    }
  }
}
</style>
